import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
export function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (<div role="tabpanel" hidden={value !== index} id={`scrollable-force-tabpanel-${index}`} aria-labelledby={`scrollable-force-tab-${index}`} {...other}>
        {value === index && (<Box p={3}>
            <Typography>{children}</Typography>
        </Box>)}
    </div>);
}
